import classNames from 'classnames';
import React, { useContext, useEffect, useMemo } from 'react';
import Button from '../../../GbsUI/UI/Button';
import ArrowRightIcon from '../../../GbsUI/UI/icons/ArrowRight';
import { SignupContext } from '../context';

const ACTIONS = [
  {
    key: 'student',
    title: 'Full-Time Student',
    description: 'Students enrolled full-time, including those interning or working part-time during their studies.',
    link: '/signup/school',
    location: 'react',
    icon: '/img/student-signup.webp',
  },
  {
    key: 'experienced-professional',
    title: 'Full-Time Professional',
    description:
      'Professionals currently working full-time, including those who are part-time students.',
    link: '/signup/firm',
    location: 'react',
    icon: '/img/signup-new.webp',
  },
  {
    key: 'recent-graduate',
    title: 'All Others',
    description: 'Job seekers, recent graduates, incoming banking analysts, career switchers, and others in transition.',
    link: '/signup/school',
    location: 'react',
    icon: '/img/recent-graduate.webp',
  },
];

const SignupIndex = (props) => {
  const {state, setState, resetState} = useContext(SignupContext);
  const selected = useMemo(() => {
    return ACTIONS.find((action) => action.key === state.flow) || ACTIONS[0];
  }, [state.flow]);

  useEffect(() => {
    resetState();
  }, [resetState]);

  useEffect(() => {
    const params = new URLSearchParams(props.history.location.search);
    const ref = params.get('ref');

    if (ref) {
      props.history.replace(props.history.location.pathname);
      setState((current) => ({
        ...current,
        ref
      }));
    }
  }, [props.history, setState]);

  return (
    <div className={'signup-start'}>
      <div className={'signup-start__header'}>
        <h1 className={'signup__title'}>Welcome to GoBuyside</h1>
        <p className={'signup__description'}>Which profile fits you best?</p>
      </div>
      <div className={'signup-start__actions'}>
        {ACTIONS.map((action) => (
          <label className={classNames('signup-start__action start-action', {
            'start-action--active': action.key === selected.key
          })} key={action.key}>
            <span className={'start-action__radio'}>
              <input
                type={'radio'}
                name={'action'}
                checked={action.key === selected.key}
                value={action.key}
                onChange={() => {
                  setState({
                    ...state,
                    flow: action.key,
                    experience: {
                      ...state.experience,
                      flow: ['experienced-professional', 'student'].includes(action.key) ? action.key : null
                    }
                  });
                }}
              />
              <span></span>
            </span>
            <img src={action.icon} width={240} height={240} alt={action.title}/>
            <h3 className={'start-action__title'}>{action.title}</h3>
            <p className={'start-action__description'}>{action.description}</p>
          </label>
        ))}
      </div>
      <div className={'signup-start__footer'}>
        <Button
          type={'button'}
          className={'signup-start__button'}
          onClick={() => {
            if (selected.location === 'react') {
              props.history.push(selected.link);
            } else {
              window.location.href = selected.link;
            }
          }}
          icon={ArrowRightIcon}
          iconPosition={'right'}
        >
          Get Started
        </Button>
      </div>
    </div>
  )
}

export default SignupIndex
